export const AUDIT_LOG_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/vault77/auditLog`;
